import { useParams } from "react-router-dom";
import {
    isTaskRejectProducts,
    isTaskUpdateProductBalances,
} from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { InventoryProductsPage } from "./InventoryProductsPage";

const InventoryProducts = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !currentPoint) return <NotFound />;

    const isRejectTask = isTaskRejectProducts(currentTask);

    if (!isTaskUpdateProductBalances(currentTask) && !isRejectTask) {
        return <NotFound />;
    }

    return (
        <InventoryProductsPage
            point={currentPoint}
            task={currentTask}
            isRejectTask={isRejectTask}
        />
    );
};

export default InventoryProducts;
